import { Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import PartnerDetailModal from '../../components/partners/PartnerDetailModal';
import PartnerListComponent from '../../components/partners/PartnerListComponent';
import { RootState } from '../../modules';
import {
  deletePartnerAsync,
  getPartnerListAsync,
} from '../../modules/partners';

interface PartnerListContainerProps {
  enterpriseId: string;
  projectId: string;
}

function PartnerListContainer({
  match,
  history,
}: RouteComponentProps<PartnerListContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const { data, loading, error } = useSelector(
    (state: RootState) => state.partners.partners,
  );

  const [partnerId, setPartnerId] = useState<any>(null);
  const [visiblePartnerDetailModal, setVisiblePartnerDetailModal] =
    useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPartnerListAsync.request({ enterpriseId, projectId }));
  }, [dispatch, enterpriseId, projectId]);

  const _openPartnerDetailModal = async (partnerId: string) => {
    setPartnerId(partnerId);
    setVisiblePartnerDetailModal(true);
  };

  const _deletePartner = async (partnerId: string) => {
    dispatch(
      deletePartnerAsync.request({ enterpriseId, projectId, partnerId }),
    );
  };

  return (
    <>
      {loading && <Spin />}
      {error && <p style={{ textAlign: 'center' }}>에러 발생!</p>}
      {data && (
        <PartnerListComponent
          partners={data}
          isProjectLevel={projectId !== undefined}
          deletePartner={_deletePartner}
          openPartnerDetailModal={_openPartnerDetailModal}
        />
      )}

      {visiblePartnerDetailModal && (
        <PartnerDetailModal
          visible={visiblePartnerDetailModal}
          enterpriseId={enterpriseId}
          projectId={projectId}
          partnerId={partnerId}
          onCancel={() => {
            setVisiblePartnerDetailModal(false);
          }}
        />
      )}
    </>
  );
}

export default PartnerListContainer;
